import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import NoInvitesIcon from '../../../Cutesies/NoInvitesIcon';
import InvitationsStore from './Store';
import Head from './Table/Head';
import { MulticheckStore } from '../../../../Multicheck/Store';
import { InvitationResource } from './Store/Types';

interface Props {
  store: InvitationsStore;
  multicheckStore: MulticheckStore<InvitationResource>;
}

function NoInvitations({ store, multicheckStore }: Props) {
  return (
    <>
      <table className="min-w-full divide-y divide-gray-300">
        <Head
          searchParameters={store.searchParameters}
          multicheckStore={multicheckStore}
          sorting={store.sorting}
        />
      </table>
      <div className="text-center py-5 flex flex-col items-center">
        <NoInvitesIcon />
        <div className="text-xl font-bold mt-5">
          <T kind="Invited participants will appear here" />
        </div>
        <div>
          <T kind="Invite some participants and/or groups to get started." />
        </div>
      </div>
    </>
  );
}

export default observer(NoInvitations);
